import { render, staticRenderFns } from "./RouteExtended.vue?vue&type=template&id=c002e640&lang=html&"
import script from "./RouteExtended.vue?vue&type=script&lang=js&"
export * from "./RouteExtended.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports